import { ConferencesBlock } from 'components/AdminV2/Blocks/ConferencesBlock/ConferencesBlock'
import { ContractorsBlock } from 'components/AdminV2/Blocks/ContractorsBlock/ContractorsBlock'
import { ElockBlock } from 'components/AdminV2/Blocks/ElockBlock/ElockBlock'
import { FaqBlock } from 'components/AdminV2/Blocks/FaqBlock/FaqBlock'
import { SortingCentersBlock } from 'components/AdminV2/Blocks/SortingCentersBlock/SortingCentersBlock'

import {
  ConferenceData,
  ContractorData,
  ElockData,
  FaqData,
  SectionData,
  SectionName,
  SortingCentersData,
} from '../../types/types'

export type SectionState = {
  title: string
  type: SectionName
  content: SectionData
  index: number
  landingComponent?: () => JSX.Element
  menuComponent?: () => JSX.Element
}

export type PromoPageState = {
  sections: SectionState[]
  isChangesUpdatingBlocked?: boolean
}

export const initialPromoPageState: PromoPageState = {
  isChangesUpdatingBlocked: false,
  sections: [
    {
      index: 0,
      title: 'Частые вопросы',
      type: SectionName.faq,
      content: [
        {
          index: 0,
          question: 'Как открыть пункт выдачи222?',
          answer:
            ' <ol>\n    <li>Откройте ИП или ООО.</li>\n    <li>Изучите <a target=`_blank` href="https://map.wb.ru/">тепловую карту</a> и найдите помещение: нежилое, на 1 этаже и с отдельным входом.</li>\n    <li>Подайте заявку через сайт или приложение WB point.</li>\n    <li>Оплатите заявку с любой карты.</li>\n    <li>Когда заявку одобрят, сделайте ремонт.</li>\n    <li>Подайте заявку на активацию.</li>\n    </ol>\n    <p>Рассказываем обо всём подробнее в <a href="#opening-video">пошаговой видеоинструкции</a>.</p>\n',
        },
        {
          index: 1,
          question: 'Какие у вас требования к ремонту?',
          answer:
            '<p>Рассказываем о требованиях <a target=`_blank` href="https://point-promo.wb.ru/docs/brandbook.pdf">в брендбуке</a>. Там же найдёте полезные советы и рекомендации. А ещё у нас есть <a href="#opening-video">пошаговая видеоинструкция</a> о том, как открыть ПВЗ &mdash; посмотрите её, чтобы больше узнать о ремонте.</p>',
        },
        {
          index: 2,
          question: 'Где найти информацию о тарифах?',
          answer:
            '<p><a target=`_blank` href="https://map.wb.ru/">На тепловой карте</a>. Выберите место, где хотите открыть пункт выдачи &mdash; появится всплывающее окно с информацией об условиях и примерном доходе. Чтобы узнать больше, нажмите кнопку &laquo;Подробнее в калькуляторе&raquo; или стрелочку в левом верхнем углу.</p>\n    <p>Если хотите рассчитать примерную прибыль, укажите товарооборот, стоимость аренды и другие расходы, а также площадь помещения &mdash; от неё будет зависеть тариф.</p>\n',
        },
        {
          index: 3,
          question: 'Когда подавать заявку на активацию и как быстро её рассмотрят?',
          answer:
            ' <p>У вас есть 30 дней на ремонт и оформление пункта. Подготовьтесь заранее и подавайте заявку на активацию не позднее, чем через 25 дней, чтобы осталось время на доработки.&nbsp;</p>\n    <p>Заявки рассматриваем в порядке очереди &mdash; обычно в течение 2 дней. Если открываете ПВЗ далеко от центра России, может понадобиться больше времени.</p>\n    <p>Если не успеваете доделать ремонт, напишите в поддержку. Для этого нажмите круглую кнопку в правом нижнем углу, а затем &mdash; &laquo;Задать вопрос менеджеру&raquo; вверху чата. Заполните форму, и специалист Wildberries свяжется с вами.</p>\n   ',
        },
        {
          index: 4,
          question: 'Что означают цвета на тепловой карте?',
          answer:
            '<p>Мы обозначили самые выгодные зоны фиолетовым цветом.</p>\n    <ul>\n    <li>серый &mdash; рядом уже есть пункт выдачи</li>\n    <li>белый &mdash; базовый тариф</li>\n    <li>светло-фиолетовая зона &mdash; повышенный тариф</li>\n    <li>тёмно-фиолетовая зона &mdash; повышенный тариф и дополнительная помощь: субсидия или гарантированный доход</li>\n    </ul>\n        <p>В странах СНГ субсидию даём во всех зонах.</p>\n    ',
        },
        {
          index: 5,
          question: 'Когда вокруг моего пункта появится серая зона?',
          answer: '<p>Карта обновится в течение 15 минут после того, как вы оплатите заявку.&nbsp;</p>',
        },
        {
          index: 6,
          question: 'От чего зависит размер серой зоны?',
          answer:
            ' <p>От пешей доступности ПВЗ, количества заказов и площади: чем больше пункт выдачи, тем больше серая зона вокруг него.<br /><br />Если ваш пункт выдачи перегружен, мы изменим цвет зоны на фиолетовый.&nbsp;</p>',
        },
        {
          index: 7,
          question: 'Не могу зарегистрироваться из-за ошибки «ИНН\u00A0не\u00A0найден»',
          answer:
            '<p>Обычно эта ошибка отображается, если вы совсем недавно оформили ИНН. В этом случае нужно немного подождать, чтобы информация обновилась в системе.&nbsp;</p>\n    <p>Если вы оформили ИНН давно, проверьте, нет ли ошибки в номере.</p>\n',
        },
        {
          index: 8,
          question: 'Не могу зарегистрироваться из-за ошибки «Собственник с таким ИНН уже зарегистрирован»',
          answer:
            '<p>Значит вы уже регистрировались под этим ИНН. Попробуйте войти в свой профиль по\u00A0номеру телефона.</p>',
        },
        {
          index: 9,
          question: 'Сколько денег нужно, чтобы открыть пункт выдачи?',
          answer:
            '<p>Траты будут зависеть от того, в каком состоянии ваше помещение. В среднем на ремонт и подготовку 1 пункта выдачи нужно от 300 000 ₽.</p>',
        },
        {
          index: 10,
          question: 'Какие есть требования к площади?',
          answer:
            '<p>Если открываете ПВЗ в России</p>\n    <p>В городе-миллионнике:&nbsp;</p>\n    <ul>\n    <li>в фиолетовой зоне &mdash; от 30 м&sup2;</li>\n    <li>в белой зоне &mdash; от 50 м&sup2;</li>\n    </ul>\n    <p>В небольшом городе &mdash; от 30 м&sup2;</p>\n    <p>Если открываете ПВЗ в странах СНГ</p>\n    <ul>\n    <li>в Астане и Алматы &mdash; от 40 м&sup2;</li>\n    <li>в других городах Казахстана &mdash; от 50 м&sup2;</li>\n    <li>в других странах СНГ &mdash; от 50 м&sup2;</li>\n    </ul>\n    ',
        },
        {
          index: 11,
          question: 'Можно открыть пункт выдачи в подвале или на 2 этаже?',
          answer:
            '     <p>Нет. Для пункта выдачи подходят помещения только на 1 этаже с отдельным входом. Это удобно для маломобильных посетителей, родителей с маленькими детьми и курьеров, которые привозят товары в пункт выдачи.</p>\n        <p>Если в вашем районе нет подходящих вариантов, сможем рассмотреть помещение на цокольном этаже, но только с лестницей не больше 7 ступеней.&nbsp;</p>\n    ',
        },
        {
          index: 12,
          question: 'Я собираюсь оформить ИП для пункта выдачи. Какой ОКВЭД выбрать?',
          answer:
            '     <p>Вам нужен код 47.9: &laquo;Торговля розничная по почте или по информационно-коммуникационной сети Интернет&raquo;.</p>\n        <p>Дополнительные виды ОКВЭД можете выбрать из этого списка:&nbsp;</p>\n        <ul>\n    <li>53.20: &laquo;Деятельность почтовой связи прочая и курьерская деятельность&raquo;</li>\n    <li>52.29: &laquo;Деятельность вспомогательная прочая, связанная с перевозками&raquo;</li>\n    <li>53.10: &laquo;Деятельность почтовой связи общего пользования&raquo;</li>\n    <li>52.10.9: &laquo;Хранение и складирование прочих грузов&raquo;</li>\n    <li>96.09: &laquo;Предоставление прочих персональных услуг, не включенных в другие группировки&raquo;</li>\n    </ul>\n',
        },
        {
          index: 13,
          question: 'У вас есть гарантийный взнос? Как его оплатить?',
          answer:
            '     <p>Да, 10 000 ₽ или 50 000 ₽ в зависимости от условий, на которых вы открываете пункт выдачи. Эта сумма вернётся на ваш счёт после того, как ПВЗ активируют. Вы можете оплатить взнос любой банковской картой.&nbsp;</p>\n        <p>Если помещение не одобрят, деньги вернутся на вашу карту в течение 30 дней. Но если решите не открываться по уже одобренной заявке, гарантийный взнос не вернётся.</p>\n    ',
        },
        {
          index: 14,
          question: 'Что дают в подарок новым пунктам?',
          answer:
            '     <p>Дарим контроллер для электронного замка, вывеску и кронштейн. Установите их до того, как подавать заявку на активацию пункта выдачи.&nbsp;</p>\n        <p>Для вывесок используйте только эти артикулы &mdash; другие не подойдут:</p>\n        <ul>\n    <li>кронштейн: 209248151&nbsp;&nbsp;</li>\n    <li>вывеска WB фиолетовая: 221540807&nbsp;&nbsp;</li>\n    <li>вывеска WB белая: 221540808</li>\n    </ul>\n        <p>Если открываете пункт выдачи в Ереване, закажите вывеску у местных производителей, и мы компенсируем 180 000 ֏.&nbsp;</p>\n        <p>Не забудьте установить электронный замок &mdash; это обязательное условие для всех регионов, за исключением северных. Вам нужно купить замок самостоятельно, а контроллер получите в подарок.&nbsp;</p>\n        <p>Посмотрите <a target=`_blank` href="https://disk.yandex.ru/i/xa_bvH7fnmN9lQ">инструкцию, как заказать оборудование в подарок</a>.&nbsp;</p>\n    ',
        },
        {
          index: 15,
          question: 'Мне нужно передать ключи курьеру, если в пункте выдачи есть электронный замок?',
          answer: '      <p>Нет. Курьер, как и менеджер пункта выдачи, будет открывать дверь через приложение.</p>\n\n',
        },
        {
          index: 16,
          question: 'Когда я смогу приступить к ремонту помещения?',
          answer:
            '  <p>Дождитесь, пока вашу заявку одобрят. Потом приступайте к ремонту.&nbsp;</p>\n    <p>Используйте <a target=`_blank` href="https://point-promo.wb.ru/docs/brandbook.pdf">брендбук</a> &mdash; собрали в этом документе все требования к пункту выдачи.</p>\n',
        },
        {
          index: 17,
          question: 'Что нужно, чтобы пункт активировали?',
          answer:
            '<p>После ремонта снимите видеообзор.</p>\n    <p>Что должно быть на записи:</p>\n    <ol>\n    <li>Адресная табличка на вашем доме. Если её нет, покажите в кадре табличку на ближайшем.</li>\n    <li>Обзор окрестностей пункта выдачи.</li>\n    <li>Фасад с вывеской и табличкой с режимом работы.</li>\n    <li>Электронный замок в торце двери, провод к контроллеру и сам контроллер &mdash; покажите его вблизи, чтобы было видно, что устройство работает.</li>\n    <li>Обзор клиентской зоны: бренд-стена, стол менеджера, примерочные и общий вид помещения. Важно зафиксировать на видео все брендированные элементы.</li>\n    <li>Обзор складской зоны.</li>\n    </ol>\n    <p>Требования к видео:&nbsp;</p>\n    <ul>\n    <li>не больше 200 Мб</li>\n    <li>не длиннее 30 секунд &mdash; можно немного ускорить, чтобы уложиться&nbsp;</li>\n    <li>без монтажа и нарезки</li>\n    </ul>\n    ',
        },
        {
          index: 18,
          question: 'Я могу выдавать товары других маркетплейсов в пункте выдачи Wildberries?',
          answer:
            '     <p>Да, можете. Главное, чтобы пункт соответствовал всем требованиям <a target=`_blank` href="https://point-promo.wb.ru/docs/brandbook.pdf">брендбука</a>.</p>\n        <p>Что нельзя делать:&nbsp;</p>\n    <ul>\n    <li>рекламировать в ПВЗ Wildberries другие маркетплейсы</li>\n    <li>выдавать товары с Wildberries в ПВЗ других маркетплейсов</li>\n    </ul>\n    ',
        },
        {
          index: 19,
          question: 'В пункте выдачи можно установить вендинговый аппарат или постамат?',
          answer: '    <p>Да, если в помещении достаточно места.</p>\n    ',
        },
        {
          index: 20,
          question: 'Почему мою заявку удалили?',
          answer:
            '     <p>Скорее всего у вашей заявки истёк срок действия. Оплаченная заявка активна в течение 30 дней с момента оформления, а неоплаченная &mdash; 24 часа. Если срок действия истёк, вы можете подать новую заявку, но гарантийный взнос в таком случае не вернётся.</p>\n        <p>Ещё специалисты могут запросить у вас дополнительную информацию и отправить заявку на доработку &mdash; у вас будет 5 дней с момента подачи заявки, чтобы ответить.&nbsp;</p>\n    <p>Если не успеваете или у вас есть вопросы, напишите в поддержку. Для этого нажмите круглую кнопку в правом нижнем углу, а затем &mdash; &laquo;Задать вопрос менеджеру&raquo; вверху чата. Заполните форму, и специалист Wildberries свяжется с вами.</p>\n    ',
        },
        {
          index: 21,
          question: 'Что такое субсидия?',
          answer:
            '      <p>Это разовая выплата. Её получит владелец, когда пункт достигнет оборота в 3 млн ₽. Если ПВЗ в другой стране, пересчитаем сумму по актуальному курсу ЦБ в местной валюте.</p>\n        <p>Размер субсидии зависит от региона &mdash; посмотреть сумму можно <a target=`_blank` href="https://map.wb.ru/#2.6/62/92">в калькуляторе</a>.</p>\n    ',
        },
        {
          index: 22,
          question: 'Что такое гарантированный доход?',
          answer:
            '    <p>Это форма финансовой помощи для новичков в некоторых регионах. В Москве и Санкт-Петербурге гарантированный доход &mdash; 200 000 ₽, а в Московской, Ленинградской и Калининградской областях &mdash; 150 000 ₽.<br /><br />Если в течение первых 3 месяцев собственник не заработает установленную сумму, мы доплатим разницу. Например, гарантированный доход пункта &mdash; 200 000 ₽. Если в 1-й месяц пункт заработает 150 000 ₽, собственнику доплатят 50 000 ₽.</p>\n        <p>Если закроете ПВЗ раньше, чем через 11 месяцев после открытия, придётся возместить Wildberries доплату, которую вы уже успели получить.</p>\n    ',
        },
        {
          index: 23,
          question: 'Я могу открыть ПВЗ Wildberries где-то кроме России?',
          answer: '    <p>Да, можете: в Армении, Беларуси, Казахстане, Кыргызстане и Узбекистане.</p>\n',
        },
        {
          index: 24,
          question: 'Как связаться с поддержкой?',
          answer:
            '     <p>Нажмите круглую кнопку в правом нижнем углу, а затем &mdash; &laquo;Задать вопрос менеджеру&raquo; вверху чата. Заполните форму, и специалист Wildberries свяжется с вами.</p>\n    ',
        },
        {
          index: 25,
          question: 'Где купить форму для сотрудников ПВЗ?',
          answer:
            '     <p>Закажите брендированную одежду на Wildberries. Подойдут эти артикулы:</p>\n        <ul>\n    <li>худи: 76011281</li>\n    <li>свитшот: 76015068</li>\n    <li>футболка: 76012699</li>\n    <li>жилет: 76017942</li>\n    </ul>\n        <p>Можете купить бланковые вещи фирменного фиолетового цвета и самостоятельно нанести на них логотип Wildberries.</p>\n    ',
        },
        {
          index: 26,
          question: 'Где купить пакеты?',
          answer:
            '     <p>На Wildberries. Используйте эти артикулы &mdash; другие не подойдут:&nbsp;</p>\n        <ul>\n    <li>маленький пакет: 109108940</li>\n    <li>средний пакет: 209785740, 16020241</li>\n    <li>большой пакет: 107004643</li>\n    </ul>\n        <p>Пакеты бесплатные для клиентов. Мы будем возмещать деньги, которые вы потратите на покупку пакетов для пункта выдачи.</p>\n',
        },
      ] as FaqData[],
      //landingComponent: FaqSection,
      menuComponent: FaqBlock,
    },
    {
      index: 1,
      title: 'Онлайн конференции',
      type: SectionName.conferences,
      content: {
        conferenceData: {},
      } as ConferenceData,
      //landingComponent: FaqSection,
      menuComponent: ConferencesBlock,
    },
    {
      index: 2,
      title: 'Сортировочные центры',
      type: SectionName.sortingCenters,
      content: {
        sortingCentersData: [
          {
            city: 'Архангельск',
            address: 'Ленина 29',
            workTime: 'Понедельник – Воскресенье, 8:00-20:00. Ворот нет, заезд через шлагбаум.',
            index: 0,
          },
          {
            city: 'Астрахань',
            address: 'Астрахань улица Рождественского 17',
            workTime:
              'Понедельник – Пятница, 11:00-18:00. Ориентир - начало пандуса, если смотреть на склад - с левой стороны будет.',
            index: 1,
          },
          {
            city: 'Барнаул',
            address: 'Барнаул проспект Ленина 154',
            workTime: 'Понедельник – Пятница, 9:00-18:00',
            index: 2,
          },
          {
            city: 'Белгород',
            address: 'улица Константина Заслонова, 94А',
            workTime: 'Понедельник – Воскресенье, 9:00-18:00',
            index: 3,
          },
          {
            city: 'Брянск',
            address: 'Брянская область, Брянск, Сталелитейная улица, 1',
            workTime: 'Понедельник – Воскресенье, 10:00-18:00. 12 ворота',
            index: 4,
          },
          {
            city: 'Владикавказ',
            address: 'Республика Северная Осетия — Алания, Пригородный район, село Михайловское, Бесланское шоссе, 17',
            workTime: 'Понедельник – Воскресенье, 10:00-20:00',
            index: 5,
          },
          {
            city: 'Волгоград',
            address: 'Авторемонтная улица, 11В',
            workTime: 'Понедельник – Пятница, 9:00 – 18:00',
            index: 6,
          },
          {
            city: 'Вологда',
            address: 'Окружное шоссе, 13, Вологда',
            workTime: 'Понедельник – Пятница, 10:00-17:00',
            index: 7,
          },
          {
            city: 'Воронеж',
            address: '1-я Промышленная зона 9 (10 ворота)',
            workTime: '24/7',
            index: 8,
          },
          {
            city: 'Гомель',
            address: 'Улица Могилевская 1/А',
            workTime: 'Понедельник – Пятница, 9:00 – 18:00',
            index: 9,
          },
          {
            city: 'Екатеринбург',
            address: 'улица Перспективная, 12/2',
            workTime: '24/7. По приезду уточнить номер ворот по телефону +79935028133',
            index: 10,
          },
          {
            city: 'Иркутск',
            address: 'Трактовая улица 18/38',
            workTime: 'Понедельник – Воскресенье, 9:00 – 19:00',
            index: 11,
          },
          {
            city: 'Казань',
            address: 'Зеленодольский район, г. Зеленодольск, промышленная площадка "Новая Тура", строение 9',
            workTime: 'На охране нужно объяснить, что за вывеской, охрана берет номер телефона и делают пропуск, 24/7',
            index: 12,
          },
          {
            city: 'Кемерово',
            address: 'Кемеровская область, Кемерово, улица Тухачевского, 58',
            workTime: 'Понедельник – Пятница, 12:00-16:00. 1 ворота, 1 пандус',
            index: 13,
          },
          {
            city: 'Краснодар',
            address: 'Тихорецкая улица, 40с1 (100 - 101 ворота для выдачи)',
            workTime: 'Понедельник – Воскресенье, 12:00 – 17:00',
            index: 14,
          },
          {
            city: 'Красноярск',
            address: 'Полигонная улица, 8Д',
            workTime: '24/7',
            index: 15,
          },
          {
            city: 'Минск',
            address: 'Минская кольцевая автомобильная дорога, 21',
            workTime: 'с 10:00 до 21:00',
            index: 16,
          },
          {
            city: 'Мурманск',
            address: 'Мурманская область, Мурманск, Промышленная улица, 19',
            workTime: 'Понедельник – Воскресенье, 10:00-18:00. Ворота 1, 2',
            index: 17,
          },
          {
            city: 'Набережные Челны',
            address: 'г. Набережные Челны, ул. Моторная 16',
            workTime: 'Понедельник – Пятница, 10:00-18:00. Ворота 1',
            index: 18,
          },
          {
            city: 'Новокузнецк',
            address: 'г. Новокузнецк, просп. Курако, д. 51а, корпус 23',
            workTime: 'Понедельник – Воскресенье, 10:00-18:00',
            index: 19,
          },
          {
            city: 'Новосибирск',
            address: 'улица Петухова, 71',
            workTime: 'Первое крыльцо, отдел отгрузок, Понедельник – Воскресенье, 10:00 – 18:00',
            index: 20,
          },
          {
            city: 'Пермь',
            address: 'Промышленная улица, 123А (ворота 2)',
            workTime: 'Понедельник – Пятница, 10:00 – 18:00',
            index: 21,
          },
          {
            city: 'Пятигорск',
            address:
              'Ставропольский край, Предгорный муниципальный округ, автодорога Пятигорск - Георгиевск, 4-й километр, 1',
            workTime: 'Понедельник – Пятница, 10:00-18:00. Ворота 3-4',
            index: 22,
          },
          {
            city: 'Ростов-на-Дону',
            address: 'улица Гайдара, 8к1, хутор Нижнетемерницкий, Щепкинское сельское поселение',
            workTime: '24/7',
            index: 23,
          },
          {
            city: 'Санкт-Петербург',
            address: 'промзона Уткина Заводь, 4к4, Свердловское городское поселение, Всеволожский район',
            workTime: '24/7',
            index: 24,
          },
          {
            city: 'Серов',
            address: 'Серов Новоуральская улица 2А',
            workTime: 'Понедельник – Пятница, 10:00-18:00',
            index: 25,
          },
          {
            city: 'Симферополь',
            address: 'Московское шоссе, 12-й километр',
            workTime: '24/7',
            index: 26,
          },
          {
            city: 'Смоленск',
            address: 'ул. Лавочкина 107',
            workTime: 'Понедельник – Пятница, 10:00 – 17:00. Со стороны ворот, где баннер Wildberries',
            index: 27,
          },
          {
            city: 'Тамбов',
            address: 'Тамбов Тамбовская область, городской округ Тамбов Волжская улица 71Б',
            workTime: 'Понедельник – Пятница, 12:00-16:00',
            index: 28,
          },
          {
            city: 'Тюмень',
            address: 'Харьковская улица, 77/1, микрорайон Сельскохозяйственный Институт',
            workTime: 'Понедельник – Пятница, 10:00 – 18:00',
            index: 29,
          },
          {
            city: 'Ульяновск',
            address: 'г. Ульяновск, 14 инженерный проспект, 9А',
            workTime: 'Понедельник – Воскресенье, 9:00-18:00',
            index: 30,
          },
          {
            city: 'Хабаровск',
            address: 'Хабаровский край, г.Хабаровск, ул. Зеленая д. 3А',
            workTime:
              'Понедельник – Пятница, 10:00-18:00. Для получения пройти в дверь к посту охраны и попросить провести к администрации',
            index: 31,
          },
          {
            city: 'Чебоксары',
            address: 'Чувашская Республика, г. Чебоксары, проезд Лапсарский, д. 55, строение 1',
            workTime: 'Вторник, Среда 12:00-16:00',
            index: 32,
          },
          {
            city: 'Челябинск',
            address: 'Координаты: 55,14918° С, 61,44944° В',
            workTime:
              'Заезд на территорию склада осуществляется с улицы Копейское шоссе, после ТЦ "Алмаз" съезд направо, далее еще один съезд правее, далее прямо и после знака главной дороги следующий съезд направо, далее прямо и напротив Автоцентра "Планета Авто" поворот направо на территорию склада',
            index: 33,
          },
          {
            city: 'Чита',
            address: 'Казачья улица, 29',
            workTime:
              'Понедельник – Пятница, 14:00 – 18:00. Первые ворота, звонок снизу, уточнить, что приехали за вывеской ВБ',
            index: 34,
          },
          {
            city: 'Ярославль',
            address: 'Промышленная улица, 22',
            workTime: '24/7',
            index: 35,
          },
        ],
      } as SortingCentersData,
      //landingComponent: FaqSection,
      menuComponent: SortingCentersBlock,
    },
    {
      index: 3,
      title: 'Рекомендуемые поставщики',
      type: SectionName.contractors,
      content: {
        videoConnectionData: [],
        signboardData: [],
        outsourcingData: [],
        description: '',
      } as ContractorData,
      //landingComponent: FaqSection,
      menuComponent: ContractorsBlock,
    },
    {
      index: 4,
      title: 'Электронный замок',
      type: SectionName.elock,
      content: {
        elockTableData: [],
        elockHowToInstallData: [],
      } as ElockData,
      menuComponent: ElockBlock,
    },
  ],
}
